import { fromEvent } from 'rxjs';
import VMasker from 'vanilla-masker';
import splitOnLastSpace from 'utils/splitOnLastSpace';
import postRegistrationData from 'api/postSaveContact';

const notificationErrorClass = 'nhs-u-background-color--peach-800';
const notificationSuccessClass = 'nhs-u-background-color--teal-600';

/* DOM Elements */
const submitButton = document.querySelector('[data-registration-form-submit]');
const emailInput = document.querySelector('[data-registration-form-email]');
const phoneInput = document.querySelector('[data-registration-form-phone]');
const termsCheckbox = document.querySelector('[data-registration-form-terms]');
const nameInput = document.querySelector('[data-registration-form-name]');
const form = document.querySelector('[data-registration-form]');
const notificationWrapper = document.querySelector(
  '[data-registration-form-notification]'
);

/**
 * Handles the form submission by gathering input data,
 * sending it to the backend, and displaying success or error messages.
 */
const submitButtonHandler = async () => {
  const fullName = nameInput ? nameInput.value : '';
  // we assume the name follows the English convention of "First Middle Last"
  // so we split on the last space to get first and last names
  const [firstName, lastName] = splitOnLastSpace(fullName);
  const data = {
    email: emailInput ? emailInput.value : '',
    phone: phoneInput ? phoneInput.value : '',
    termsAccepted: termsCheckbox ? termsCheckbox.checked : false,
    firstName,
    lastName,
  };

  // hide previous notification and clear message
  notificationWrapper.hidden = true; // Hide notification initially
  notificationWrapper.textContent = ''; // Clear previous messages
  notificationWrapper.classList.remove(
    notificationSuccessClass,
    notificationErrorClass
  );

  try {
    const response = await postRegistrationData(data);

    if (response) {
      const message = 'Thank you for signing up!'
      form.reset(); // Reset the form on success
      submitButton.disabled = true; // Disable the submit button to prevent empty submissions
      notificationWrapper.textContent = message;
      notificationWrapper.classList.add(notificationSuccessClass);
      notificationWrapper.hidden = false;
      const customEvent = new CustomEvent('successful_registration', {
        detail: message
      });
      form.dispatchEvent(customEvent);
    }
  } catch (error) {
    notificationWrapper.textContent = 'There was an error processing your registration. Please try again later.';
    notificationWrapper.classList.add(notificationErrorClass);
    notificationWrapper.hidden = false;
    const customEvent = new CustomEvent('failed_registration', {
      detail: error.message
    });
    form.dispatchEvent(customEvent);
  }
};

const submitFormHandler = (event) => {
  event.preventDefault();
};

/**
 * Sets up event listeners for form interaction events.
 * This includes input, focus, and select events for the email, phone, and name inputs,
 * as well as change and focus events for the terms checkbox.
 */
export default function setupFormInteractionEvents() {
  // setup phone input masking
  if (phoneInput) {
    VMasker(phoneInput).maskPattern('(999) 999-9999');
  }

  fromEvent(form, "submit").subscribe(submitFormHandler);

  if (submitButton) {
    fromEvent(submitButton, 'click').subscribe(submitButtonHandler);
  }
}

